import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$2 = ".LoadingBar_module_container__3a991498{background-color:var(--st-muted);border-radius:var(--st-rounded-full);height:var(--st-spacing);overflow:clip}.LoadingBar_module_progress__3a991498{animation:LoadingBar_module_loading__3a991498 10s cubic-bezier(.22,1,.36,1);background-color:var(--st-primary);height:100%;width:100%}@keyframes LoadingBar_module_loading__3a991498{0%{transform:translateX(-100%)}to{transform:translateX(-1%)}}";
collectCss(css$2);
var modules_2f9e3bf6 = {"container":"LoadingBar_module_container__3a991498","progress":"LoadingBar_module_progress__3a991498"};

export { css$2 as css, modules_2f9e3bf6 as default };
//# sourceMappingURL=LoadingBar.module.css.mjs.map
